import React, { useState, useEffect } from 'react';
import * as api from '../../services/api';

function Categorias() {
  const [categorias, setCategorias] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(null);
  const [modoEdicion, setModoEdicion] = useState(false);
  const [categoriaEditando, setCategoriaEditando] = useState(null);
  const [formData, setFormData] = useState({ nombre: '', orden: '' });
  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [mensaje, setMensaje] = useState(null);

  useEffect(() => {
    cargarCategorias();
  }, []);

  const cargarCategorias = async () => {
    try {
      setCargando(true);
      const response = await api.getCategorias();
      setCategorias(response.data);
      setError(null);
    } catch (err) {
      console.error('Error al cargar categorías:', err);
      setError('Error al cargar las categorías');
    } finally {
      setCargando(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      if (modoEdicion && categoriaEditando) {
        await api.actualizarCategoria(categoriaEditando.id, formData);
        setMensaje({ tipo: 'success', texto: 'Categoría actualizada exitosamente' });
      } else {
        await api.crearCategoria(formData);
        setMensaje({ tipo: 'success', texto: 'Categoría creada exitosamente' });
      }
      
      await cargarCategorias();
      resetFormulario();
      setMostrarFormulario(false);
      
      // Limpiar mensaje después de 3 segundos
      setTimeout(() => setMensaje(null), 3000);
    } catch (err) {
      console.error('Error al guardar categoría:', err);
      setError(err.response?.data?.error || 'Error al guardar la categoría');
      setTimeout(() => setError(null), 5000);
    }
  };

  const handleEditar = (categoria) => {
    setCategoriaEditando(categoria);
    setFormData({ nombre: categoria.nombre, orden: categoria.orden });
    setModoEdicion(true);
    setMostrarFormulario(true);
    setError(null);
    setMensaje(null);
  };

  const handleEliminar = async (id, nombre) => {
    if (!window.confirm(`¿Está seguro de eliminar la categoría "${nombre}"?\n\nNota: Solo se puede eliminar si no tiene platos asociados.`)) {
      return;
    }

    try {
      await api.eliminarCategoria(id);
      setMensaje({ tipo: 'success', texto: `Categoría "${nombre}" eliminada exitosamente` });
      await cargarCategorias();
      setTimeout(() => setMensaje(null), 3000);
    } catch (err) {
      console.error('Error al eliminar categoría:', err);
      setError(err.response?.data?.error || 'Error al eliminar la categoría');
      setTimeout(() => setError(null), 5000);
    }
  };

  const resetFormulario = () => {
    setFormData({ nombre: '', orden: '' });
    setCategoriaEditando(null);
    setModoEdicion(false);
  };

  const handleNuevaCategoria = () => {
    resetFormulario();
    setMostrarFormulario(true);
    setError(null);
    setMensaje(null);
  };

  const handleCancelar = () => {
    resetFormulario();
    setMostrarFormulario(false);
    setError(null);
  };

  if (cargando) {
    return (
      <div>
        <div className="page-header">
          <h1>Categorías de Platos</h1>
        </div>
        <div className="card">
          <p>Cargando categorías...</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="page-header">
        <h1>📂 Categorías de Platos</h1>
        <p>Gestiona las categorías disponibles para clasificar los platos del menú</p>
      </div>

      {mensaje && (
        <div style={{
          background: mensaje.tipo === 'success' ? '#d4edda' : '#fff3cd',
          color: mensaje.tipo === 'success' ? '#155724' : '#856404',
          padding: '12px 20px',
          borderRadius: '8px',
          marginBottom: '20px',
          border: `1px solid ${mensaje.tipo === 'success' ? '#c3e6cb' : '#ffeeba'}`,
          display: 'flex',
          alignItems: 'center',
          gap: '10px'
        }}>
          <span>{mensaje.tipo === 'success' ? '✅' : 'ℹ️'}</span>
          <span>{mensaje.texto}</span>
        </div>
      )}

      {error && (
        <div style={{
          background: '#f8d7da',
          color: '#721c24',
          padding: '12px 20px',
          borderRadius: '8px',
          marginBottom: '20px',
          border: '1px solid #f5c6cb',
          display: 'flex',
          alignItems: 'center',
          gap: '10px'
        }}>
          <span>❌</span>
          <span>{error}</span>
        </div>
      )}

      <div className="card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h2>Categorías Existentes ({categorias.length})</h2>
          {!mostrarFormulario && (
            <button className="btn btn-primary" onClick={handleNuevaCategoria}>
              ➕ Nueva Categoría
            </button>
          )}
        </div>

        {mostrarFormulario && (
          <div style={{
            background: '#f8f9fa',
            padding: '25px',
            borderRadius: '10px',
            marginBottom: '25px',
            border: '2px solid #1e5945'
          }}>
            <h3 style={{ marginTop: 0, color: '#1e5945' }}>
              {modoEdicion ? '✏️ Editar Categoría' : '➕ Nueva Categoría'}
            </h3>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Nombre de la Categoría *</label>
                <input
                  type="text"
                  className="form-control"
                  value={formData.nombre}
                  onChange={(e) => setFormData({ ...formData, nombre: e.target.value })}
                  required
                  placeholder="Ej: Entrada, Principal, Postre, Bebida, etc."
                  autoFocus
                />
              </div>

              <div className="form-group">
                <label>Orden de Visualización</label>
                <input
                  type="number"
                  className="form-control"
                  value={formData.orden}
                  onChange={(e) => setFormData({ ...formData, orden: e.target.value })}
                  placeholder="Orden en que aparecerá (opcional)"
                  min="0"
                  style={{ maxWidth: '200px' }}
                />
                <small style={{ color: '#7f8c8d', fontSize: '13px', marginTop: '5px', display: 'block' }}>
                  Si no se especifica, se asignará automáticamente al final
                </small>
              </div>

              <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
                <button type="submit" className="btn btn-success">
                  {modoEdicion ? '💾 Guardar Cambios' : '➕ Crear Categoría'}
                </button>
                <button type="button" className="btn btn-secondary" onClick={handleCancelar}>
                  ✖ Cancelar
                </button>
              </div>
            </form>
          </div>
        )}

        {categorias.length === 0 ? (
          <div style={{
            textAlign: 'center',
            padding: '60px 20px',
            background: '#f8f9fa',
            borderRadius: '8px',
            border: '2px dashed #dee2e6'
          }}>
            <div style={{ fontSize: '48px', marginBottom: '15px' }}>📂</div>
            <p style={{ color: '#7f8c8d', fontSize: '16px', marginBottom: '20px' }}>
              No hay categorías creadas todavía.
            </p>
            {!mostrarFormulario && (
              <button className="btn btn-primary" onClick={handleNuevaCategoria}>
                ➕ Crear Primera Categoría
              </button>
            )}
          </div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table>
              <thead>
                <tr>
                  <th style={{ width: '80px', textAlign: 'center' }}>Orden</th>
                  <th>Nombre</th>
                  <th style={{ width: '80px', textAlign: 'center' }}>ID</th>
                  <th style={{ width: '200px', textAlign: 'center' }}>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {categorias.map((categoria) => (
                  <tr key={categoria.id}>
                    <td style={{ textAlign: 'center', fontWeight: '700', fontSize: '16px', color: '#1e5945' }}>
                      {categoria.orden}
                    </td>
                    <td>
                      <strong style={{ fontSize: '15px' }}>{categoria.nombre}</strong>
                    </td>
                    <td style={{ textAlign: 'center', color: '#7f8c8d', fontSize: '14px' }}>
                      #{categoria.id}
                    </td>
                    <td style={{ textAlign: 'center' }}>
                      <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                        <button
                          className="btn btn-primary"
                          onClick={() => handleEditar(categoria)}
                          style={{ padding: '8px 16px', fontSize: '14px' }}
                        >
                          ✏️ Editar
                        </button>
                        <button
                          className="btn btn-danger"
                          onClick={() => handleEliminar(categoria.id, categoria.nombre)}
                          style={{ padding: '8px 16px', fontSize: '14px' }}
                        >
                          🗑️ Eliminar
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <div className="card" style={{ marginTop: '20px', background: '#f8f9fa' }}>
        <h3 style={{ color: '#1e5945', marginTop: 0 }}>ℹ️ Información sobre Categorías</h3>
        <ul style={{ paddingLeft: '25px', lineHeight: '1.9', color: '#2c3e50' }}>
          <li><strong>Organización:</strong> Las categorías se usan para organizar los platos en el menú diario</li>
          <li><strong>Orden:</strong> El número de orden determina cómo aparecen en la interfaz de usuario (menor número = primero)</li>
          <li><strong>Eliminación:</strong> No puedes eliminar una categoría si tiene platos asociados</li>
          <li><strong>Unicidad:</strong> Los nombres de categorías deben ser únicos en el sistema</li>
          <li><strong>Ejemplos:</strong> Entrada, Principal, Guarnición, Postre, Bebida, Ensalada, etc.</li>
        </ul>
      </div>
    </div>
  );
}

export default Categorias;
